<template>
  <div>
    <router-link to="/repairDetail"><p>维修</p></router-link>
  </div>
</template>

<script>
export default {
  name: 'repair'
}
</script>

<style scoped>
</style>
